module.exports = __webpack_public_path__ + "img/camera.fc0b27ee.svg";